import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import UsersSearch from "../dashboard/calender/UsersSearch";
import ApiService from "../util/ApiService";

const AddUserToSpecialtyModal = ({ show, onHide, specialty, onSuccess }) => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleAddUser = async () => {
        if (!selectedUser?.value) {
            Swal.fire("Atenção", "Selecione um usuário antes de adicionar.", "warning");
            return;
        }

        setLoading(true);
        try {
            const params = {
                specialty_id: specialty?.id,
                user_id: selectedUser.value
            };
            const response = await ApiService.send("post", `${process.env.REACT_APP_URL_API}specialties/register-user`, params, true);

            if (response.code === 200) {
                Swal.fire("Sucesso", "Usuário adicionado à especialidade!", "success");
                onSuccess();
                setSelectedUser(null);
                onHide();
            } else {
                Swal.fire("Erro", "Erro ao adicionar o usuário.", "error");
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Adicionar Usuário à Especialidade
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <p>
                 Nome:<strong> {specialty?.name}</strong>
                </p>
                <br/>

                <UsersSearch
                    onUserSelect={(user) => setSelectedUser(user)}
                />
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={onHide} disabled={loading}>Cancelar</button>
                <button className="btn btn-success" onClick={handleAddUser} disabled={loading || !selectedUser}>
                    <i className="fa fa-plus"></i> Adicionar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddUserToSpecialtyModal;
